<tax-page-header titleText="groups.title" [rightSide]="groupsOptions">
  <ng-template #groupsOptions>
    <a class="like-button" data-qa-link="create-group" [routerLink]="'0'" translate>groups.add</a>
  </ng-template>
</tax-page-header>

<tax-input
  placeholder="groups.search.placeholder"
  [formControl]="groupSearchInput"
  [autofocus]="true"
  [clearable]="true"
  class="search-input"
  data-qa-input="search-group"
></tax-input>

<ng-container *ngIf="groups$ | async as groups">
  <div class="group-list ui-kit-rows-layout" data-qa-block="filter">
    <div
      class="group-item"
      *ngFor="let group of groups; trackBy: trackById"
      [routerLink]="[group.id]"
      data-qa="group"
      data-qa-link="group-page"
    >
      <tax-icon name="group" class="group-icon"></tax-icon>
      <div class="group-name" data-qa="group-name">
        {{ group.title }}
      </div>
      <div class="group-counter" data-qa="users-count">
        {{ 'groups.user.counter' | translate }} {{ group.users.length }}
      </div>
    </div>
  </div>

  <tax-empty-list *ngIf="groups.length === 0" text="group.empty.list"></tax-empty-list>
</ng-container>
